import { useEffect, useState } from "react";

export function useReseñas(csvUrl) {
  const [reseñas, setReseñas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(csvUrl)
      .then((res) => res.text())
      .then((text) => {
        const rows = text.split("\n").filter((r) => r.trim() !== "");
        const headers = rows[0].split(",");

        const data = rows.slice(1).map((row) => {
          const values = row.split(",");
          let obj = {};

          headers.forEach((h, i) => {
            obj[h.trim()] = values[i]?.trim() || "";
          });

          return obj;
        });

        setReseñas(data);
        setLoading(false);
      });
  }, [csvUrl]);

  return { reseñas, loading };
}
